import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import React, { Fragment, useRef, useState } from 'react'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import { useToast } from 'tennders-common/hooks/useToast'
import usePopup from 'tennders-common/hooks/usePopup'
import GHref from 'tennders-market/common/components/element/GHref'
import GCurrency from 'tennders-market/common/components/element/GCurrency'

import dynamic from 'next/dynamic'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsAltH } from '@fortawesome/free-solid-svg-icons'

const EllipsisToolTip = dynamic(() => import('ellipsis-tooltip-react-chan'), { ssr: false })

const SingleAssign = ({ toMatch }) => {
  // const [submitting, setsubmitting] = useState(false)
  const submitting = useRef(false)
  const [assigning, setassigning] = useState(false)
  const { popConfirm, popConfirmCustom } = usePopup()
  const { transaction } = useTransaction()
  const { t } = useTranslation()
  const { toastSuccess } = useToast()
  const item = toMatch?.matchedLoad || toMatch?.matchedTruck
  const { assignPairing, refreshTransaction } = useTransactions()

  const assign = (loadTransaction, truckTransaction) => {
    if (submitting?.current) {
      return
    }
    submitting.current = true
    assignPairing(loadTransaction, truckTransaction, () => {
      toastSuccess(loadTransaction?.matchedLoad
        ? t('toast:loadAssigned')
        : t('toast:truckAssigned'))
      submitting.current = false
      popConfirm(false)
      setassigning(false)
      refreshTransaction()
      window.location = '/qc/transactions'
    }, () => {
      submitting.current = false
      popConfirm(false)
    })
  }

  const triggerAssign = () => {
    if (!assigning) {
      setassigning(true)
      return
    }
    const load = toMatch?.matchedLoad ? toMatch : transaction
    const truck = toMatch?.matchedTruck ? toMatch : transaction
    setassigning(false)
    if (load?.matchedLoad?.truckType?.id !== truck?.matchedTruck?.truckType?.id) {
      popConfirmCustom({
        title: 'Truck Types don\'t match',
        message: 'Truck type requested by Load Provider is different than what has been assigned.',
        extraContent: (
          <>
            <div className="d-flex flex-col w-100 text-left">
              <span>
                <b>Requested Truck Type: </b><b className="color-red">{load?.matchedLoad?.truckType?.label}</b>
              </span>
              <br />
              <span>
                <b>Assigned Truck Type: </b><b className="color-red">{truck?.matchedTruck?.truckType?.label}</b>
              </span>
            </div>
          </>
        ),
        submitting: submitting.current,
        okTitle: 'Accept',
        cancelTitle: 'Find a different truck',
        onOk: async () => {
          assign(load, truck)
        }
      })
    } else {
      assign(load, truck)
    }
  }

  const disabled = !toMatch.isOpenToQC
  const key = toMatch?.matchedLoad ? 'notAssignableTruckMessage' : 'notAssignableLoadMessage'

  return (
    <tr>
      <td>
        <table className="tennders-table-zebra border-b">
          <tbody>
            <tr>
              <td>
                <h4 className={disabled ? 'link-disabled mb-0' : 'bold mb-0'}>{item?.company?.name}</h4>
                <div className="text-12 conform-email">
                  <EllipsisToolTip options={{ className: 'custom-color-tooltip' }}>{item?.company?.email}</EllipsisToolTip>
                </div>
                {disabled && <span>{t('transaction:' + key, { state: t('company:' + item.company?.state?.label?.toLocaleLowerCase()) })}</span>}
              </td>
              <td className="text-right">
                {assigning && (
                  <GHref
                    onClick={() => setassigning(false)}
                    className="btn-border standard-btn mr-8"
                  >
                    <Trans i18nKey="transaction:cancel" />
                  </GHref>
                )}
                <GHref
                  disabled={disabled}
                  submitting={submitting?.current}
                  onClick={triggerAssign}
                  className="btn-border standard-btn"
                >
                  {assigning
                    ? <Trans i18nKey="transaction:confirmPairing" />
                    : <Trans i18nKey="transaction:assignPairing" />}
                </GHref>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <table className="tennders-table-zebra text-center text-12">
                  <tbody>
                    <tr>
                      <td>
                        <strong>{toMatch?.pickupRoute?.label}</strong>
                        {' '}
                        <br />
                        <div className="text-mid-hray">
                          {toMatch?.pickupRoute?.date?.f}
                        </div>
                      </td>
                      <td>
                        <FontAwesomeIcon icon={faArrowsAltH} fontSize={24} className="text-mid-gray" aria-hidden="true" />
                      </td>
                      <td>
                        <strong>{toMatch?.deliveryRoute?.label}</strong>
                        {' '}
                        <br />
                        <div className="text-mid-hray">
                          {toMatch?.deliveryRoute?.date?.f}
                        </div>
                      </td>
                      <td className="text-left border-l pl-24">
                        <div>
                          Booking price:
                          {' '}
                          <strong><GCurrency value={item?.bookRate} /></strong>
                        </div>
                        <div>
                          Booker:
                          {' '}
                          <strong>{toMatch?.bookedBy?.name}</strong>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  )
}

export default React.memo(SingleAssign)
